module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.accesses-for')) + " | Controller: " + _vm._s(_vm.swithc.controllerName) + " | Switch: " + _vm._s(_vm.swithc.name))]), _vm._v(" "), _c('single-access', {
    attrs: {
      "access-holders": _vm.accessHolders,
      "unprocessed-accesses": _vm.unprocessedAccesses,
      "columns": ['contact_name'],
      "switch-id": _vm.switchId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-317eec0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/SingleSwitchAccess.vue
// module id = 1138
// module chunks = 2